var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHousing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11667 9.4137V22.5257C4.11667 22.7164 4.27214 22.8733 4.46427 22.8733H8.68534C8.87747 22.8733 9.03294 22.7164 9.03294 22.5257V16.8292C9.03294 16.6385 9.1884 16.4816 9.38054 16.4816H13.9008C14.0929 16.4816 14.2484 16.6385 14.2484 16.8292V22.5257C14.2484 22.7164 14.4039 22.8733 14.596 22.8733H18.8171C19.0092 22.8733 19.1647 22.7164 19.1647 22.5257V9.4137",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.6407L10.9336 2.70711C11.3241 2.31658 11.9572 2.31658 12.3478 2.70711L22.2813 12.6407",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4073 11.5106C13.4073 12.4859 12.6153 13.2765 11.6399 13.2765C10.6646 13.2765 9.87405 12.4859 9.87405 11.5106C9.87405 10.5338 10.6646 9.74326 11.6399 9.74326C12.6153 9.74326 13.4073 10.5338 13.4073 11.5106Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousing);
export default __webpack_public_path__ + "static/media/housing.1f38359b.svg";
export { ForwardRef as ReactComponent };